import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const VoiceIcon: FC<Props> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.75 9.8009C20.164 9.8009 20.5 10.1369 20.5 10.5509C20.5 15.1431 16.9754 18.9235 12.5003 19.3069L12.5 21.75C12.5 22.164 12.164 22.5 11.75 22.5C11.336 22.5 11 22.164 11 21.75L11.0007 19.307C6.52514 18.924 3 15.1434 3 10.5509C3 10.1369 3.336 9.8009 3.75 9.8009C4.164 9.8009 4.5 10.1369 4.5 10.5509C4.5 14.5689 7.752 17.8389 11.75 17.8389C15.748 17.8389 19 14.5689 19 10.5509C19 10.1369 19.336 9.8009 19.75 9.8009ZM11.75 1C14.403 1 16.561 3.167 16.561 5.831V10.519C16.561 13.182 14.403 15.349 11.75 15.349C9.097 15.349 6.938 13.182 6.938 10.519V5.831C6.938 3.167 9.097 1 11.75 1ZM11.75 2.5C9.924 2.5 8.438 3.994 8.438 5.831V10.519C8.438 12.354 9.924 13.849 11.75 13.849C13.551 13.849 15.0203 12.3946 15.0602 10.5941L12.8205 10.5938C12.4065 10.5938 12.0705 10.2578 12.0705 9.8438C12.0705 9.4298 12.4065 9.0938 12.8205 9.0938L15.06 9.093V7.255L13.8186 7.2559C13.4046 7.2559 13.0686 6.9199 13.0686 6.5059C13.0686 6.0919 13.4046 5.7559 13.8186 5.7559L15.058 5.755L15.0557 5.64224C14.9582 3.89274 13.513 2.5 11.75 2.5Z"
        fill={props.fill || "currentColor" || "black"}
      />
    </svg>
  );
};

export default VoiceIcon;
